import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import { convertToAbsoluteImageURI, computeImageSourceType } from "../../Helpers/image";
import { X, XX, XXX, MODE, GIF_EXT, WEBP_PNG_TYPE, mobileSupportedWidths, desktopSupportedWidths, WIDTH_320, PNG_EXT, SVG_EXT } from "../../Constants/image";
import withConfig from "../../ComponentDependency/withConfig";
import DependencyManager from "../../DependencyManager";
import { MOBILE } from "../../Constants/platform";
import { compose } from 'redux';
import { withComponentDependency } from "../../ComponentDependency/withComponentDependency";
export var ImageWrapper = function ImageWrapper(_ref) {
  var image = _ref.image,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    config = _ref.config,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? '' : _ref$id;
  var staticAssetUrl = config === null || config === void 0 ? void 0 : config.get('staticAssets');
  var placeHolders = {
    staticAssets: staticAssetUrl,
    scalingParam: XX,
    mode: MODE.LIGHT,
    width: WIDTH_320,
    ext: image.url.includes('$ext') ? PNG_EXT : ''
  };
  var _image$isLazyLoaded = image.isLazyLoaded,
    isLazyLoaded = _image$isLazyLoaded === void 0 ? true : _image$isLazyLoaded,
    height = image.height,
    width = image.width,
    fetchpriority = image.fetchpriority,
    _image$decoding = image.decoding,
    decoding = _image$decoding === void 0 ? 'async' : _image$decoding;
  var _useState = useState(image.url),
    _useState2 = _slicedToArray(_useState, 2),
    src = _useState2[0],
    setSrc = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    errored = _useState4[0],
    setErrored = _useState4[1];
  var _image$alt = image.alt,
    alt = _image$alt === void 0 ? '' : _image$alt,
    defaultUrl = image.defaultUrl;
  useEffect(function () {
    setSrc(image.url);
    setErrored(false);
  }, [image]);
  var isImageValid = function isImageValid(src) {
    var promise = new Promise(function (resolve) {
      var img = document.createElement('img');
      img.onerror = function () {
        return resolve(false);
      };
      img.onload = function () {
        return resolve(true);
      };
      img.src = convertToAbsoluteImageURI(src, placeHolders);
    });
    return promise;
  };
  useEffect(function () {
    if (defaultUrl && !errored) {
      isImageValid(src).then(function (isValid) {
        if (!isValid) {
          setSrc(defaultUrl);
          setErrored(true);
        }
      });
    }
  }, [src, setSrc, defaultUrl, errored, isImageValid]);
  var defaultImgTag = function defaultImgTag() {
    var restProps = {};
    if (height) {
      restProps.height = height;
    }
    if (width) {
      restProps.width = width;
    }
    if (fetchpriority) {
      restProps.fetchpriority = fetchpriority;
    }
    if (decoding) {
      restProps.decoding = decoding;
    }
    if (isLazyLoaded) {
      restProps.loading = 'lazy';
    }
    return /*#__PURE__*/React.createElement("img", Object.assign({
      id: id,
      alt: alt,
      className: className,
      style: image.style,
      src: convertToAbsoluteImageURI(src, placeHolders)
    }, restProps));
  };
  var getSrcSet = function getSrcSet() {
    if (src.includes('$scalingParam$')) {
      return "".concat(convertToAbsoluteImageURI(src, Object.assign(Object.assign({}, placeHolders), {
        scalingParam: X
      })), " ").concat(X, ",\n                ").concat(convertToAbsoluteImageURI(src, Object.assign(Object.assign({}, placeHolders), {
        scalingParam: XX
      })), " ").concat(XX, ",\n            ").concat(convertToAbsoluteImageURI(src, Object.assign(Object.assign({}, placeHolders), {
        scalingParam: XXX
      })), " ").concat(XXX);
    }
    return convertToAbsoluteImageURI(src, placeHolders);
  };
  var getSourceForDifferentWidth = function getSourceForDifferentWidth(type) {
    placeHolders.ext = type;
    var PanameraConstants = DependencyManager.getDependency('constants');
    var platform = PanameraConstants.platform;
    var platformWidths = platform === MOBILE ? mobileSupportedWidths : desktopSupportedWidths;
    if (src.includes('$width$')) {
      return platformWidths.map(function (width, index) {
        placeHolders.width = width;
        return /*#__PURE__*/React.createElement("source", {
          key: "".concat(type, "_").concat(width, "_").concat(index),
          media: "(max-width: ".concat(width, "px)"),
          type: computeImageSourceType(type),
          srcSet: getSrcSet()
        });
      });
    }
    return [/*#__PURE__*/React.createElement("source", {
      key: "".concat(type),
      type: computeImageSourceType(type),
      srcSet: getSrcSet()
    })];
  };
  var renderSources = function renderSources() {
    var sources = [];
    if (src.includes('.gif')) {
      sources = getSourceForDifferentWidth(GIF_EXT);
    } else if (src.includes('.svg')) {
      sources = getSourceForDifferentWidth(SVG_EXT);
    } else {
      sources = WEBP_PNG_TYPE.reduce(function (s, type) {
        s = [].concat(_toConsumableArray(s), _toConsumableArray(getSourceForDifferentWidth(type)));
        return s;
      }, []);
    }
    return sources;
  };
  var renderDifferentType = function renderDifferentType() {
    if ((src.includes('.svg') || src.includes('.gif')) && !src.includes('$width')) {
      return defaultImgTag();
    }
    return /*#__PURE__*/React.createElement("picture", {
      style: image.pictureStyle
    }, renderSources(), defaultImgTag());
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, (image === null || image === void 0 ? void 0 : image.url) && renderDifferentType());
};
export default compose(withComponentDependency, withConfig)(/*#__PURE__*/React.memo(ImageWrapper));